var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.712 0C251.837 0 258.056 3.609 260.619 8.062L365.715 192H479.998C515.343 192 576 220.656 576 256S515.343 320 479.998 320H365.715L260.587 503.938C257.744 508.922 252.431 512 246.712 512H181.211C170.586 512 162.898 501.812 165.836 491.594L214.868 320H111.991L68.802 377.594C65.771 381.625 61.021 384 55.99 384H15.989C5.582 384 -2.043 374.219 0.488 364.125L31.989 256L0.488 147.875C-2.043 137.781 5.582 128 15.989 128H55.99C61.021 128 65.771 130.375 68.802 134.406L111.991 192H214.868L165.836 20.391C162.898 10.172 170.586 0 181.211 0H246.712L246.712 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.8f430cd9d26c1929ba6ada5ac1e99047.svg";
export { ForwardRef as ReactComponent };